"use strict";

exports.__esModule = true;
exports.default = void 0;

/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
var APIFactory = require('gemini/lib/@waca/dashboard-common/dist/core/APIFactory');

var _default = APIFactory;
exports.default = _default;
